import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../assets/logo.png";
import { API_BASE_URL } from "../config";
import SupportOtpPanel from "../components/admin/SupportOtpPanel";

import {
  FaTrash,
  FaUserShield,
  FaListUl,
  FaTachometerAlt,
  FaClipboardList,
} from "react-icons/fa";
const money = (v) =>
  v === null || v === undefined || isNaN(v)
    ? "—"
    : `$${Number(v).toFixed(2)}`;



const AdminConsole = () => {
  const [users, setUsers] = useState([]);
  const [listings, setListings] = useState([]);
  const [logs, setLogs] = useState([]);
  const [userActivity, setUserActivity] = useState([]);
  const [salesHistory, setSalesHistory] = useState([]);
  const [metrics, setMetrics] = useState(null);
  const [activeTab, setActiveTab] = useState("dashboard");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [selectedSnapshot, setSelectedSnapshot] = useState(null);
  const [logSearch, setLogSearch] = useState("");
  const [listingSearch, setListingSearch] = useState("");
const [salesSearch, setSalesSearch] = useState("");
const downloadPDF = async () => {

  const element = document.getElementById("snapshot-content");

  if (!element) {
    alert("Snapshot not found ❌");
    return;
  }

  const canvas = await html2canvas(element, { scale: 2 });

  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF("p", "mm", "a4");

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgHeight = (canvas.height * pageWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight);

  heightLeft -= pageHeight;

  while (heightLeft > 0) {

    position = heightLeft - imgHeight;

    pdf.addPage();

    pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight);

    heightLeft -= pageHeight;
  }

  const ref =
    selectedSnapshot?.transactionRef ||
    selectedSnapshot?.listing?.listingId ||
    "client-exchange-sale";

  pdf.save(`ClientExchange-Sale-${ref}.pdf`);
};



  const categoryColor = (type) => {
    if (!type) return "#000";
    if (type.includes("LOGIN")) return "#1565c0"; // blue
    if (type.includes("VERIFICATION")) return "#6a1b9a"; // purple
    if (type.includes("LISTING")) return "#2e7d32"; // green
    if (type.includes("HANDOVER")) return "#ef6c00"; // orange
    if (type.includes("SWAP")) return "#00838f"; // teal
    if (type.includes("STRIPE")) return "#d81b60"; // pink
    return "#000";
  };

  const token = localStorage.getItem("token");
  const green = "#2e7d32";

  // === Normalizer ===
  const normalizeArray = (res) => {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    for (const val of Object.values(res)) {
      if (Array.isArray(val)) return val;
    }
    if (res.data && Array.isArray(res.data.rows)) return res.data.rows;
    return [];
  };

  const showMessage = (msg) => {
    setMessage(msg);
    setTimeout(() => setMessage(""), 3000);
  };

  // === API actions ===
  const toggleSuspend = async (id, isSuspended) => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/users/${id}/suspend`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ isSuspended: !isSuspended }),
      });
      if (res.ok) {
        showMessage(!isSuspended ? "User suspended ✅" : "User unsuspended ✅");
        fetchAllData();
      } else {
        showMessage("Failed to change user status ❌");
      }
    } catch (err) {
      console.error(err);
      showMessage("Error performing action ❌");
    }
  };

  const toggleVerify = async (id, isVerified) => {
    try {
      await fetch(`${API_BASE_URL}/api/admin/listings/${id}/verify`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ isVerified: !isVerified }),
      });
      await fetchAllData();
    } catch (err) {
      console.error(err);
      showMessage("Error verifying listing ❌");
    }
  };

  const deleteListing = async (id) => {
    if (!window.confirm("Delete this listing?")) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/listings/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        showMessage("Listing deleted ✅");
        await fetchAllData();
      } else {
        showMessage("Failed to delete listing ❌");
      }
    } catch (err) {
      console.error(err);
      showMessage("Error deleting listing ❌");
    }
  };

  const openSnapshot = (snapshot) => {
    if (!snapshot) return alert("❌ No snapshot data available");
    try {
      const parsed =
        typeof snapshot === "object"
          ? snapshot
          : JSON.parse(snapshot || "{}");
      setSelectedSnapshot(parsed);
    } catch (err) {
      console.error("❌ Snapshot parse error:", err);
      alert("Snapshot format invalid ❌");
    }
  };

  // === Fetch All ===
  const fetchAllData = async () => {
    try {
      const [uRes, lRes, logRes, actRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/admin/users`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        fetch(`${API_BASE_URL}/api/admin/listings`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        fetch(`${API_BASE_URL}/api/admin/audit-logs`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        fetch(`${API_BASE_URL}/api/admin/user-activity`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      const [usersJ, listingsJ, logsJ, activityJ] = await Promise.all([
        uRes.json(),
        lRes.json(),
        logRes.json(),
        actRes.json(),
      ]);

      setUsers(normalizeArray(usersJ));
      setListings(normalizeArray(listingsJ));
      setLogs(normalizeArray(logsJ));
      setUserActivity(normalizeArray(activityJ));
    } catch (err) {
      console.error("❌ Error fetching data:", err);
      showMessage("Failed to load admin data");
    }
  };

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        if (activeTab === "dashboard") {
          const res = await fetch(`${API_BASE_URL}/api/admin/metrics`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const data = await res.json();
          setMetrics(data?.data ?? data ?? null);
        } else if (
          ["users", "listings", "logs", "userActivity"].includes(activeTab)
        ) {
          await fetchAllData();
        } else if (activeTab === "salesHistory") {
          const res = await fetch(`${API_BASE_URL}/api/admin/sales-history`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const data = await res.json();
          setSalesHistory(normalizeArray(data));
        }
      } catch (err) {
        console.error("❌ Load error:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [activeTab]);

  if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>Admin Console</h1>
      {message && <p style={messageStyle}>{message}</p>}

      <div style={tabContainerStyle}>
        {[
          ["dashboard", <FaTachometerAlt key="d" />, "Dashboard"],
          ["users", <FaUserShield key="u" />, "Users"],
          ["listings", <FaListUl key="l" />, "Listings"],
          ["logs", <FaClipboardList key="lg" />, "Logs"],
          ["userActivity", <FaClipboardList key="ua" />, "User Activity"],
          ["salesHistory", <FaClipboardList key="sh" />, "Sales History"],
        ].map(([key, icon, label]) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            style={activeTab === key ? activeTabStyle(green) : tabStyle}
          >
            {icon} {label}
          </button>
        ))}
      </div>

      {/* === Dashboard === */}
      {activeTab === "dashboard" && metrics && (
        <div style={cardStyle}>
          <h2 style={sectionTitle}>Platform Overview</h2>
         <div style={metricsGrid}>
  <div style={metricCard("#1e88e5")}>
    <div style={metricLabel}>Total Users</div>
    <div style={metricValue}>{metrics.totalUsers}</div>
  </div>

  <div style={metricCard("#43a047")}>
    <div style={metricLabel}>Total Swaps Available</div>
    <div style={metricValue}>{metrics.activeSwaps ?? 0}</div>

  </div>

  <div style={metricCard("#f9a825")}>
    <div style={metricLabel}>Admins</div>
    <div style={metricValue}>{metrics.admins}</div>
  </div>

  <div style={metricCard("#6d4c41")}>
    <div style={metricLabel}>Active Listings</div>
    <div style={metricValue}>{metrics.activeListings}</div>
  </div>
</div>

        </div>
      )}

      {/* === Users === */}
      {activeTab === "users" && (
        <div style={cardStyle}>
          <h2 style={sectionTitle}>All Users</h2>
          <SupportOtpPanel token={token} />
          <div style={{ overflowX: "auto", width: "100%" }}>
  <table style={{ ...tableStyle, minWidth: "900px" }}>
            <thead style={{ background: green, color: "#fff" }}>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Verified</th>
                <th>Verified Date</th>
                <th>Proof Ref</th>
                <th>Suspended</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td>{u.id}</td>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>
  {u.licence_verified === 1
    ? "✅ VERIFIED"
    : "❌ NOT VERIFIED"}
</td>
                  <td>
                    {u.verified_date
                      ? new Date(u.verified_date).toLocaleString()
                      : "—"}
                  </td>
                  <td>{u.apiReference || "—"}</td>
                  <td>{u.isSuspended ? "Yes" : "No"}</td>
                  <td>
                    <button
                      style={buttonStyle(
                        u.isSuspended ? "#43a047" : "#c62828"
                      )}
                      onClick={() => toggleSuspend(u.id, u.isSuspended)}
                    >
                      {u.isSuspended ? "Unsuspend" : "Suspend"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      )}

      {/* === Listings === */}
      {activeTab === "listings" && (
        <div style={cardStyle}>
          <h2 style={sectionTitle}>All Listings</h2>
          <input
  type="text"
  placeholder="Search listings..."
  value={listingSearch}
  onChange={(e) => setListingSearch(e.target.value)}
  style={{
    padding: "8px 12px",
    marginBottom: "15px",
    width: "100%",
    maxWidth: "350px",
    borderRadius: "6px",
    border: "1px solid #ccc"
  }}
/>

          {listings.length === 0 ? (
            <p style={{ textAlign: "center" }}>No listings found.</p>
          ) : (
            <div style={{ overflowX: "auto", width: "100%" }}>
  <table style={{ ...tableStyle, minWidth: "900px" }}>
              <thead style={{ background: green, color: "#fff" }}>
                <tr>
                  <th>ID</th>
                  <th>Title</th>
                  <th>Seller</th>
                  <th>Suburb</th>
                  
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {listings
  .filter((l) => {
    if (!listingSearch) return true;
    const t = listingSearch.toLowerCase();
    return (
      String(l.title).toLowerCase().includes(t) ||
      String(l.suburb).toLowerCase().includes(t) ||
      String(l.postcode).toLowerCase().includes(t) ||
      String(l.sellerName).toLowerCase().includes(t) ||
      String(l.listingId).toLowerCase().includes(t)
    );
  })
  .map((l) => (

                  <tr key={l.id}>
                    <td>{l.listingId || l.id}</td>
                    <td>{l.title}</td>
                    <td>{l.sellerName || "—"}</td>
                    <td>{l.suburb || "—"}</td>
                   
                    <td>
                      {l.createdAt
                        ? new Date(l.createdAt).toLocaleDateString()
                        : "—"}
                    </td>
                    <td>
  <button
    style={buttonStyle("#c62828")}
    onClick={() => deleteListing(l.id)}
  >
    <FaTrash style={{ marginRight: 5 }} /> Delete
  </button>
</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>
      )}

      {/* === Logs === */}
      {activeTab === "logs" && (
        <div style={cardStyle}>
          <h2 style={sectionTitle}>Audit Logs</h2>
          {logs.length === 0 ? (
            <p style={{ textAlign: "center" }}>No audit logs found.</p>
          ) : (
           <div style={{ overflowX: "auto", width: "100%" }}>
  <table style={{ ...tableStyle, minWidth: "900px" }}>
              <thead style={{ background: green, color: "#fff" }}>
                <tr>
                  <th>ID</th>
                  <th>Admin</th>
                  <th>Action</th>
                  <th>Target</th>
                  <th>Details</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td>{log.id}</td>
                    <td>{log.adminName || "—"}</td>
                    
                    <td style={{ fontWeight: "bold", color: categoryColor(log.actionType) }}>
  {log.actionType}
</td>
                    <td>
                      {(log.targetType || "—")}
                      {log.targetId ? ` #${log.targetId}` : ""}
                    </td>
                    <td>{log.details || "—"}</td>
                    <td>
                      {log.createdAt
                        ? new Date(log.createdAt).toLocaleString()
                        : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>
      )}

      {/* === User Activity === */}
      {activeTab === "userActivity" && (
        <div style={cardStyle}>
          <h2 style={sectionTitle}>User Activity Logs</h2>
          <input
  type="text"
  placeholder="Search logs..."
  value={logSearch}
  onChange={(e) => setLogSearch(e.target.value)}
  style={{
    padding: "8px 12px",
    marginBottom: "15px",
    width: "100%",
    maxWidth: "350px",
    borderRadius: "6px",
    border: "1px solid #ccc"
  }}
/>

          {userActivity.length === 0 ? (
            <p style={{ textAlign: "center" }}>No user activity logs found.</p>
          ) : (
            <div style={{ overflowX: "auto", width: "100%" }}>
  <table style={{ ...tableStyle, minWidth: "900px" }}>
              <thead style={{ background: green, color: "#fff" }}>
                <tr>
                  <th>ID</th>
                  <th>User</th>
                  <th>Action</th>
                  <th>Listing</th>
                  <th>Details</th>
                  <th>IP Address</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {userActivity
  .filter((log) => {
    if (!logSearch) return true;
    const text = logSearch.toLowerCase();
    return (
      String(log.actionType).toLowerCase().includes(text) ||
      String(log.userName).toLowerCase().includes(text) ||
      String(log.details).toLowerCase().includes(text) ||
      String(log.listingId).toLowerCase().includes(text) ||
      String(log.ipAddress).toLowerCase().includes(text)
    );
  })
  .map((log) => (

                  <tr key={log.id}>
                    <td>{log.id}</td>
                    <td>{log.userName || log.user_email || "—"}</td>
                    <td>{log.actionType}</td>
                    <td>{log.listingId || "—"}</td>
                    <td>{log.details || "—"}</td>
                    <td>{log.ipAddress || "—"}</td>
                    <td>
                      {log.createdAt
                        ? new Date(log.createdAt).toLocaleString()
                        : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
           </table>
</div>
          )}
        </div>
      )}

      {/* === Sales History === */}
      {activeTab === "salesHistory" && (
        
        <div style={cardStyle}>
        {console.log("Sales History Snapshot:", salesHistory)}

          <h2 style={sectionTitle}>Sales History</h2>
          {console.log("Sales History Snapshot:", salesHistory)}

          <input
  type="text"
  placeholder="Search sales..."
  value={salesSearch}
  onChange={(e) => setSalesSearch(e.target.value)}
  style={{
    padding: "8px 12px",
    marginBottom: "15px",
    width: "100%",
    maxWidth: "350px",
    borderRadius: "6px",
    border: "1px solid #ccc"
  }}
/>

          {salesHistory.length === 0 ? (
            <p style={{ textAlign: "center" }}>No sales history found.</p>
          ) : (
            <>
              <div style={{ overflowX: "auto", width: "100%" }}>
  <table style={{ ...tableStyle, minWidth: "900px" }}>
                <thead style={{ background: green, color: "#fff" }}>
                  <tr>
                    <th>ID</th>
                    <th>List ID</th>
                    <th>Buyer</th>
                    <th>Seller</th>
                    <th>Suburb</th>
                    <th>Price</th>
                    <th>Ref</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {salesHistory
  .filter((s) => {
    if (!salesSearch) return true;
    const t = salesSearch.toLowerCase();
    return (
      String(s.listingId).toLowerCase().includes(t) ||
      String(s.buyerName).toLowerCase().includes(t) ||
      String(s.sellerName).toLowerCase().includes(t) ||
      String(s.suburb).toLowerCase().includes(t) ||
      String(s.transactionRef).toLowerCase().includes(t)
    );
  })
  .map((s) => (
                    <tr key={s.id}>
  <td>{s.id}</td>

  {/* LIST ID */}
  <td>
    {s.snapshot?.listing?.id || 
     s.listingId || 
     s.title || 
     "—"}
  </td>

  {/* BUYER */}
  <td>
    {s.snapshot?.buyer?.name ||
     s.buyerName ||
     "—"}
  </td>

  {/* SELLER */}
  <td>
    {s.snapshot?.seller?.name ||
     s.sellerName ||
     "—"}
  </td>

  {/* SUBURB */}
  <td>
    {s.snapshot?.listing?.suburb ||
     s.suburb ||
     "—"}
  </td>

  {/* PRICE */}
  <td>
    $
    {s.snapshot?.listing?.price
      ? Number(s.snapshot.listing.price).toLocaleString()
      : s.price
      ? Number(s.price).toLocaleString()
      : "—"}
  </td>

  {/* REF */}
  <td>{s.transactionRef || s.ref || "—"}</td>

  {/* DATE */}
  <td>
    { s.saleDate
    ? new Date(s.saleDate).toLocaleDateString("en-AU")
    : "—" }

  </td>

  <td>
    <button
      className="btn btn-primary"
    onClick={() => openSnapshot(s.snapshot || s.full_snapshot)}
    >
      View Snapshot
    </button>
  </td>
</tr>

                  ))}
                </tbody>
              </table>
              </div>

              {selectedSnapshot && (
                <div style={modalOverlayStyle}>
                  <div style={modalStyle}>
                    <h3 style={{ color: green }}>Listing Snapshot</h3>
                    {/* === Enhanced Snapshot View === */}
<div
  id="snapshot-content"
  style={{
    background: "#f5f5f5",
    padding: "12px",
    borderRadius: "8px",
    marginBottom: "10px",
    fontSize: "0.9rem",
    lineHeight: "1.5",
    minHeight: "100%"
  }}
>

<div style={{ textAlign: "center", marginBottom: "10px" }}>
  <img
    src={logo}
    alt="Client Exchange"
    style={{ width: "180px" }}
  />
</div>

<h2 style={{ textAlign: "center", color: "#2e7d32" }}>
  Client Transfer Record
</h2>

 <h3 style={{ color: "#2e7d32", marginBottom: "5px" }}>
  Listing Details
</h3>

{Object.entries(selectedSnapshot?.listing || {}).map(([key, value]) => {

  if (key === "services") return null; // handled separately
  if (typeof value === "object") return null;

  return (
    <div key={key}>
      <strong>{key}:</strong> {String(value)}
    </div>
  );

})}

{selectedSnapshot?.listing?.services && (
  <>
    <hr />

    <h4 style={{ color: "#2e7d32" }}>Services Included</h4>

    {Object.entries(selectedSnapshot.listing.services).map(
      ([service, enabled]) => (
        <div key={service}>
          <strong>{service}:</strong> {enabled ? "✔ Yes" : "✖ No"}
        </div>
      )
    )}
  </>
)}
 
 <br />
  <strong>Frequency:</strong> {selectedSnapshot?.listing?.frequency || "—"} <br />
<strong>Price:</strong>{" "}
{money(
  selectedSnapshot?.listing?.salePrice ??
  selectedSnapshot?.listing?.price ??
  selectedSnapshot?.fees?.salePrice ??
  null
)}
<br />


<br />
 <strong>Transaction Ref:</strong> {selectedSnapshot?.transactionRef || "—"} <br />
<strong>Sale Date:</strong> {selectedSnapshot?.saleDate ? new Date(selectedSnapshot.saleDate).toLocaleString() : "—"}

{/* === POOL CARE DETAILS === */}
{selectedSnapshot?.category === "poolcare" && (
  <>
    <hr />

    <h4 style={{ color: "#2e7d32" }}>Pool Details</h4>

    <strong>Pool Type:</strong> {selectedSnapshot?.listing?.poolType || "—"} <br />
    <strong>Pool Size:</strong> {selectedSnapshot?.listing?.poolSize || "—"} <br />
    <strong>Surface:</strong>{" "}
{selectedSnapshot?.listing?.poolSurface ||
 selectedSnapshot?.listing?.surface ||
 "—"} <br />
    <strong>Spa Included:</strong>{" "}
    {selectedSnapshot?.listing?.hasSpa ? "✔ Yes" : "✖ No"} <br />

    <hr />

 <h4 style={{ color: "#2e7d32" }}>Included Services</h4>

<strong>Water Testing:</strong>{" "}
{selectedSnapshot?.listing?.services?.waterTesting ? "✔ Yes" : "✖ No"} <br />

<strong>Chemical Balancing:</strong>{" "}
{selectedSnapshot?.listing?.services?.chemicalBalancing ? "✔ Yes" : "✖ No"} <br />

<strong>Skimming:</strong>{" "}
{selectedSnapshot?.listing?.services?.skimming ? "✔ Yes" : "✖ No"} <br />

<strong>Vacuuming:</strong>{" "}
{selectedSnapshot?.listing?.services?.vacuuming ? "✔ Yes" : "✖ No"} <br />

<strong>Brushing:</strong>{" "}
{selectedSnapshot?.listing?.services?.brushing ? "✔ Yes" : "✖ No"} <br />

<strong>Filter Cleaning:</strong>{" "}
{selectedSnapshot?.listing?.services?.filterCleaning ? "✔ Yes" : "✖ No"} <br />

<strong>Salt Cell Cleaning:</strong>{" "}
{selectedSnapshot?.listing?.services?.saltCellCleaning ? "✔ Yes" : "✖ No"} <br />

<strong>Chemicals Included:</strong>{" "}
{selectedSnapshot?.listing?.services?.chemicalsIncluded ? "✔ Yes" : "✖ No"} <br />
  </>
)}

<hr />

  <h4 style={{ color: "#2e7d32" }}>Buyer Details</h4>
  <strong>Name:</strong> {selectedSnapshot?.buyer?.name || "—"} <br />
  <strong>Email:</strong> {selectedSnapshot?.buyer?.email || "—"} <br />
  <strong>Phone:</strong> {selectedSnapshot?.buyer?.phone || "—"} <br />
<strong>Company:</strong> {selectedSnapshot?.buyer?.companyName || selectedSnapshot?.buyer?.company || "—"} <br />
  <strong>ABN:</strong> {selectedSnapshot?.buyer?.abn || "—"} <br />

  <hr />

  <h4 style={{ color: "#2e7d32" }}>Seller Details</h4>
  <strong>Name:</strong> {selectedSnapshot?.seller?.name || "—"} <br />
  <strong>Email:</strong> {selectedSnapshot?.seller?.email || "—"} <br />
  <strong>Phone:</strong> {selectedSnapshot?.seller?.phone || "—"} <br />
  <strong>Company:</strong> {selectedSnapshot?.seller?.companyName || selectedSnapshot?.seller?.company || "—"} <br />
  <strong>ABN:</strong> {selectedSnapshot?.seller?.abn || "—"} <br />

  <hr />

  <h4 style={{ color: "#2e7d32" }}>Fees</h4>

<strong>Buyer Admin Fee (15%):</strong>{" "}
{money(
  selectedSnapshot?.fees?.buyerAdminFee ??
  selectedSnapshot?.fees?.buyerFee
)}
<br />

<strong>Listing Activation Fee:</strong>{" "}
{(
  selectedSnapshot?.fees?.listingActivationFee ??
  selectedSnapshot?.fees?.sellerFee
) === 0
  ? "Already paid upfront"
  : money(
      selectedSnapshot?.fees?.listingActivationFee ??
      selectedSnapshot?.fees?.sellerFee
    )}
<br />

<strong>Seller Payout:</strong>{" "}
{money(
  selectedSnapshot?.fees?.netSellerPayout ??
  selectedSnapshot?.fees?.sellerNet
)}






</div>




{/* Raw JSON evidence block */}
<pre
  style={{
    background: "#f5f5f5",
    padding: "10px",
    borderRadius: "8px",
    overflowX: "auto",
    maxHeight: "400px",
  }}
>
  {JSON.stringify(selectedSnapshot, null, 2)}
</pre>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >

<button
  style={buttonStyle("#2e7d32")}
  onClick={downloadPDF}
>
  Download PDF
</button>

<button
  style={buttonStyle("#1e88e5")}
  onClick={() => {
    try {
      // Modern browsers
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(
          JSON.stringify(selectedSnapshot, null, 2)
        );
        alert("Copied JSON to clipboard ✅");
      } else {
        // Fallback for local HTTP / unsupported browsers
        const temp = document.createElement("textarea");
        temp.value = JSON.stringify(selectedSnapshot, null, 2);
        document.body.appendChild(temp);
        temp.select();
        document.execCommand("copy");
        document.body.removeChild(temp);
        alert("Copied using fallback method ✅");
      }
    } catch (err) {
      console.error("Clipboard error:", err);
      alert("Clipboard copy failed ❌");
    }
  }}
>
  Copy JSON
</button>

                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

// === Styles ===
const containerStyle = {
  maxWidth: "1100px",
  margin: "40px auto",
  padding: "20px",
  background: "#fff",
  borderRadius: "10px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
};
const titleStyle = { textAlign: "center", color: "#2e7d32" };
const messageStyle = {
  textAlign: "center",
  color: "#2e7d32",
  fontWeight: "600",
};
const tabContainerStyle = {
  display: "flex",
  justifyContent: "center",
  gap: "10px",
  flexWrap: "wrap",
  marginBottom: "15px",
};
const tabStyle = {
  background: "#ccc",
  color: "#fff",
  border: "none",
  padding: "8px 18px",
  borderRadius: "6px",
  cursor: "pointer",
};
const activeTabStyle = (c) => ({ ...tabStyle, background: c });
const cardStyle = {
  background: "#fff",
  padding: "15px",
  borderRadius: "8px",
  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
  marginBottom: "25px",
};
const sectionTitle = { color: "#2e7d32", marginBottom: "10px" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const metricsGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: "16px",
  marginTop: "10px",
};
const metricCard = (bg) => ({
  background: bg,
  color: "#fff",
  padding: "15px",
  borderRadius: "10px",
  textAlign: "center",
});
const metricLabel = { fontSize: "0.9rem", opacity: 0.9 };
const metricValue = { fontSize: "26px", fontWeight: "bold" };
const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};
const modalStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  maxWidth: "750px",
  width: "90%",
  maxHeight: "90vh",     // 🔥 keeps modal within screen
  overflowY: "auto",     // 🔥 enables scrolling
  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
};

const buttonStyle = (bg) => ({
  backgroundColor: bg,
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  padding: "6px 10px",
  cursor: "pointer",
  marginRight: "6px",
});

export default AdminConsole;
